import { Pipe, PipeTransform } from '@angular/core';
import { TagOption } from '../interfaces/tag.interface';

@Pipe({
    name: 'subordinateFilter',
    pure: false,
    standalone: false
})
export class SubordinateFilterPipe implements PipeTransform {

  transform(values: TagOption[], ...args: unknown[]): unknown {
    return values.filter( v => !v.isHiddenBySubordinateLogic);
  }

}
